module.exports = __webpack_public_path__ + "static/media/background.e38aac07.mp3";